import React, { FC, useEffect, useState } from 'react';
import { CommonModal } from '../CommonModal';

// カウントダウンプログレスモーダル用のスタイル
const countdownProgressStyles = {
  container: {
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px 0',
  },
  title: {
    textAlign: 'center' as 'center',
    fontSize: '16px',
    fontWeight: 600,
    margin: '0 auto',
    marginBottom: '16px',
  },
  messageContainer: {
    width: '100%',
    textAlign: 'center' as const,
    marginBottom: '32px',
  },
  message: {
    fontSize: '14px',
    lineHeight: '24px',
    marginBottom: '8px',
  },
  nextDeliveryMessage: {
    fontSize: '16px',
    lineHeight: '26px',
    marginBottom: '20px',
    textAlign: 'center' as 'center',
    fontWeight: 600,
  },
  progressContainer: {
    width: 'calc(100% - 40px)',
    height: '16px',
    backgroundColor: '#F7F7F7',
    borderRadius: '100px',
    margin: '0 0 14px 0',
    overflow: 'hidden',
    border: '1px solid #2F8052',
  },
  progressBar: {
    height: '100%',
    backgroundColor: '#2F8052',
    borderRadius: '8px',
    transition: 'width 1s linear',
  },
  countdown: {
    fontSize: '13px',
    color: '#5D6360',
  },
};

export const CountdownProgressModal: FC<{
  active: boolean;
  duration?: number; // カウントダウンの秒数（デフォルト15秒）
  onComplete?: () => void; // カウントダウン完了時のコールバック
  nextDeliveryMessage?: string; // 次回お届け日のメッセージ
  title?: string;
}> = ({
  active,
  duration = 15,
  onComplete,
  nextDeliveryMessage = '次回のお届け日を\n4週後に変更しています。',
  title = '最短でお届けします',
}) => {
  const [secondsLeft, setSecondsLeft] = useState(duration);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (!active) {
      // モーダルが非アクティブの場合はリセット
      setSecondsLeft(duration);
      setProgress(0);
      return;
    }

    // カウントダウンと進捗バーを更新
    const interval = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          if (onComplete) {
            onComplete();
          }
          return 0;
        }
        return prev - 1;
      });

      setProgress((prev) => {
        const newProgress = prev + 100 / duration;
        return newProgress > 100 ? 100 : newProgress;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [active, duration, onComplete]);

  // モーダルが表示されたらカウントダウンを開始
  useEffect(() => {
    if (active) {
      setSecondsLeft(duration);
      setProgress(0);
    }
  }, [active, duration]);

  return (
    <CommonModal active={active}>
      <div style={countdownProgressStyles.container}>
        <div style={countdownProgressStyles.title}>{title}</div>
        <div style={countdownProgressStyles.messageContainer}>
          <div style={countdownProgressStyles.message}>
            注文確定メールをお送りしました。
            <br />
            発送の準備をはじめますので、
            <br />
            お届けまでお待ちください。
          </div>
        </div>

        <div style={countdownProgressStyles.nextDeliveryMessage}>
          {nextDeliveryMessage.split('\n').map((line, index) => (
            <React.Fragment key={index}>
              {line}
              {index < nextDeliveryMessage.split('\n').length - 1 && <br />}
            </React.Fragment>
          ))}
        </div>

        <div style={countdownProgressStyles.progressContainer}>
          <div
            style={{
              ...countdownProgressStyles.progressBar,
              width: `${progress}%`,
            }}
          />
        </div>

        <div style={countdownProgressStyles.countdown}>変更完了まであと{secondsLeft}秒</div>
      </div>
    </CommonModal>
  );
};
